<template>
    <v-menu
        v-model="mostrar"
        :close-on-content-click="false">
        <template
            v-slot:activator="{ on, attrs }">
            <v-btn
                icon
                v-bind="attrs"
                v-on="on">
                <v-icon>
                    mdi-dots-vertical
                </v-icon>
            </v-btn>
        </template>
        <v-list>
          <template
            v-if="obra.proyecto">
            <v-list-item
              :to="{ name: 'obraProyectos', params: {
                idObra: obra.id,
                idProyecto: obra.proyecto.id
                }}"
              link>
              <v-list-item-icon class="mr-2">
                <v-icon>
                  mdi-folder-cog
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Vér proyecto
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template
            v-else>
            <v-list-item
              @click="registrarProyecto"
              link>
              <v-list-item-icon class="mr-2">
                <v-icon>
                  mdi-folder-cog
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Registar Proyecto
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template
            v-if="obra.id">
            <v-list-item
            @click="generarPlantillas"
             >
              <v-list-item-icon class="mr-2">
                <v-icon>
                  mdi-file-word-outline
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Plantillas
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item
            v-if="mixValidaScopesActions(2)"
            @click="editar"
            link>
            <v-list-item-icon class="mr-2">
              <v-icon>
                mdi-pencil
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Editar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item
          v-if="mixValidaScopesActions(3)"
          @click="borrar"
            link>
            <v-list-item-icon class="mr-2">
              <v-icon>
                mdi-delete
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Eliminar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import eventBus from '@/helpers/eventBus';

export default {
  name: 'OpcionesObras',
  props: {
    obra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrar: false,
    };
  },
  methods: {
    registrarProyecto() {
      eventBus.$emit('registrar-proyecto', this.obra);
    },
    editar() {
      eventBus.$emit('editar-obra', this.obra);
    },
    borrar() {
      eventBus.$emit('eliminar-obra', this.obra);
    },
    generarPlantillas() {
      eventBus.$emit('generar-plantillas', this.obra);
    },
  },
};
</script>

<style lang="scss">

</style>
